if (!customElements.get('predictive-search')) {

window.tokenMap = {
    "lovablehn.myshopify.com": "b1abc504275bd6088aec09c095565f6a",
    "lovablerd.myshopify.com": "0632642ddbd428a4f674a583729e1480",
    "lovablecr.myshopify.com": "ecd6946dd4f277394444d89ac1af90cc",
    "lovablesv.myshopify.com": "0bec08f579cbf3b40f8e6761b8ff7b82",
    "lovableint.myshopify.com": "f303415d06b1c271a2edbbb61ea33b0a",
    "lovable-gt.myshopify.com": "e2681063d8dec7e16c1bc5380a1f7778",
    "lovableni.myshopify.com": "306ff774667eacfcb10e8ac6d20c5cb6"
  // ... other stores
};

  // --- Map of Storefront tokens per store ---
  const tokenMap = {
    "lovablehn.myshopify.com": "b1abc504275bd6088aec09c095565f6a",
    "lovablerd.myshopify.com": "0632642ddbd428a4f674a583729e1480",
    "lovablecr.myshopify.com": "ecd6946dd4f277394444d89ac1af90cc",
    "lovablesv.myshopify.com": "0bec08f579cbf3b40f8e6761b8ff7b82",
    "lovableint.myshopify.com": "f303415d06b1c271a2edbbb61ea33b0a",
    "lovable-gt.myshopify.com": "e2681063d8dec7e16c1bc5380a1f7778",
    "lovableni.myshopify.com": "306ff774667eacfcb10e8ac6d20c5cb6"
  };
  const currentStore = window.location.hostname;
  const STOREFRONT_ACCESS_TOKEN = tokenMap[currentStore];

  if (!STOREFRONT_ACCESS_TOKEN) {
    console.error("❌ No Storefront token found for this store:", currentStore);
  }

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.errorMessageText = this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      const searchDrawerContent = document.querySelector('.drawer__content--search');
      const searchSuggestions = document.querySelector('.search-drawer__suggestions');

      // --- Input event ---
      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();
          if (searchTerm.length <= 0) {
            this.close();
            if (window.innerWidth < 990) searchDrawerContent.style.height = 'auto';
            if (searchSuggestions) searchSuggestions.style.display = 'block';
            return;
          }
          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if (window.innerWidth <= 990) searchDrawerContent.style.height = '100%';
          if (searchSuggestions) searchSuggestions.style.display = 'none';
        }, 300);
      });

      // --- Escape key ---
      this.input.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          if (!this.input.value && this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
            return;
          }
          this.close();
        }
      });

      // --- Clear button ---
      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if (searchSuggestions) searchSuggestions.style.display = 'block';
      });
    }

    // --- Predictive search ---
    async getSearchResults(searchTerm) {
      try {
        console.log(`🔍 Searching for: ${searchTerm}`);
        const predictiveResponse = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) return;
        if (!predictiveResponse.ok) throw new Error(predictiveResponse.status);

        const predictiveText = await predictiveResponse.text();
        const doc = new DOMParser().parseFromString(predictiveText, 'text/html');

        const predictiveResults = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
        const hasProducts = doc.querySelector('.predictive-search__col-product')?.innerHTML.trim() !== '';

        // --- Debugging logs ---
const productCards = Array.from(doc.querySelectorAll('.predictive-item'));
console.log("🔎 Predictive search debug:");
console.log("Search term:", searchTerm);
console.log("Product cards found:", productCards.length);
console.log("Estilo attributes:", productCards.map(c => c.getAttribute('data-estilo')));

// 1) native predictive results first
this.resultsContainer.innerHTML =
  doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';

// 2) merge in estilo matches the native index can't see
try {
  const matchHandles = await EstiloIndex.match(searchTerm);
  if (!this.isOpen) return;

  if (matchHandles.length) {
    let grid = this.resultsContainer.querySelector('.predictive-search__grid');

    // native returned no product grid -> build the row/grid scaffold
    if (!grid) {
      const col = this.resultsContainer.querySelector('.predictive-search__col-product');
      if (col) {
        col.innerHTML =
          '<div class="predictive-search__row">' +
            '<h6 class="predictive-search__title">Productos</h6>' +
            '<div class="predictive-search__grid"></div>' +
          '</div>';
        grid = col.querySelector('.predictive-search__grid');
      }
    }

    if (grid) {
      const already = EstiloIndex.handlesIn(grid);
      const missing = matchHandles.filter(h => !already.has(h));
      if (missing.length) {
        grid.insertAdjacentHTML('afterbegin', await EstiloIndex.renderCards(missing));
      }
    }
  }
} catch (e) {
  console.error('Estilo merge failed:', e);
}

this.open();
document.querySelector('quick-cart-drawer')?.initTriggers();



      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    // --- GraphQL fetch by estilo ---
    async getProductsByEstilo(searchTerm) {
      if (!STOREFRONT_ACCESS_TOKEN) return; // stop if no token

      const query = `{
        products(first: 10, query: "${searchTerm}") {
          edges {
            node {
              id title handle
              featuredImage { url }
              priceRange { minVariantPrice { amount currencyCode } }
              estilo: metafield(namespace: "custom", key: "estilo") { value }
              estilo_dos_piezas: metafield(namespace: "custom", key: "estilo_dos_piezas") { value }
              variants(first: 10) {
                nodes {
                  id
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
        }
      }`;

      try {
        console.log("Store:", currentStore, "Using token:", STOREFRONT_ACCESS_TOKEN);

        const response = await fetch("/api/2025-01/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          },
          body: JSON.stringify({ query }),
        });

        const result = await response.json();
        if (!response.ok) throw new Error(`GraphQL Error: ${result.errors?.[0]?.message}`);

        const allProduct = result.data.products.edges.map(edge => {
          const variants = edge.node?.variants?.nodes.map(node => ({
            ...node,
            option1: node?.selectedOptions?.find(o => o.name === 'Color')?.value || '',
            option2: node?.selectedOptions?.find(o => o.name === 'Size')?.value || '',
          }));
          return { ...edge.node, variants };
        }).filter(product => {
          const estilo_dos_piezas = product.estilo_dos_piezas?.value?.trim().toLowerCase();
          if (!estilo_dos_piezas) {
            const estiloValue = product.estilo?.value?.trim().toLowerCase().replace(/t$/, '');
            return estiloValue === searchTerm.toLowerCase();
          }
          return estilo_dos_piezas === searchTerm.toLowerCase();
        });

        const processedProducts = processProducts(allProduct);
        const products = filterProductsByEstilo(processedProducts);

        if (products.length > 0) {
          const handles = products.map(p => p.handle);
          const productCards = await this.fetchProductCards(handles);
          this.resultsContainer.innerHTML = this.wrapResults(searchTerm, productCards);
          this.open();
        } else {
          this.resultsContainer.innerHTML = `<div class="predictive-search-no-result">No se encontraron productos con Estilo "${searchTerm}".</div>`;
          this.open();
        }

      } catch (error) {
        console.error("Error fetching products:", error);
        this.resultsContainer.innerHTML = `<div class="predictive-search-no-result">No se encontraron productos.</div>`;
        this.open();
      }
    }

// --- Fetch estilo metafields for predictive search items ---
async getExactEstiloMatches(handles, searchTerm) {
  if (!STOREFRONT_ACCESS_TOKEN) return [];

  const cleanSearch = searchTerm.trim().toLowerCase().replace(/^0+/, '');

  const query = `{
    products(first: 50, query: "handle:${handles.join(' OR handle:')}") {
      edges {
        node {
          handle
          estilo: metafield(namespace: "custom", key: "estilo") { value }
          estilo_dos_piezas: metafield(namespace: "custom", key: "estilo_dos_piezas") { value }
        }
      }
    }
  }`;

  try {
    const response = await fetch("/api/2025-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.errors?.[0]?.message || 'GraphQL error');

    return result.data.products.edges
      .filter(edge => {
        const estilo = edge.node.estilo?.value?.trim().toLowerCase().replace(/^0+/, '');
        const estiloDos = edge.node.estilo_dos_piezas?.value?.trim().toLowerCase().replace(/^0+/, '');
        return (
          estilo === cleanSearch ||
          estiloDos === cleanSearch
        );
      })
      .map(edge => edge.node.handle);
  } catch (error) {
    console.error("Error fetching estilo metafields:", error);
    return [];
  }
}



    async fetchProductCards(handles) {
      const query = handles.join(',');
      const res = await fetch(`/pages/render-product-cards?ids=${query}`);
      const renderProductCards = await res.text();
      const doc = new DOMParser().parseFromString(renderProductCards, 'text/html');
      const renderProductCardsResults = doc.querySelector('#render-product-cards')?.innerHTML || '';
      const products = doc.querySelector('.product-card')?.innerHTML.trim();
      const hasProducts = products !== '';
      if (!hasProducts) {
        return `<div class="predictive-search-no-result">No se encontraron productos con Estilo "${searchTerm}".</div>`;
      }
      return renderProductCardsResults;
    }

    // --- Render helpers ---
    wrapResults(searchTerm, content) {
      return `
        <div class="predictive-search__results" id="predictive-search-results">
          <div class="predictive-search__col predictive-search__col-product">
            <div class="predictive-search__row">
              <h6 class="predictive-search__title">Productos</h6>
              <div class="predictive-search__grid">${content}</div>
            </div>
          </div>
          <div class="predictive-search__col">
            <div class="predictive-search__row">
              <button type="submit" class="button button--text predictive-search__link">
                Ver resultados para "${searchTerm}"
              </button>
            </div>
          </div>
        </div>
      `;
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}

// --- Product processing helpers ---
function processProducts(allProduct) {
  return allProduct.map(product => {
    const estilo_dos_piezas = product.estilo_dos_piezas?.value?.trim().toLowerCase();
    const estilo = product.estilo?.value?.trim().toLowerCase();
    const subProduct = findSubProducts(allProduct, estilo_dos_piezas, estilo);
    const totalPrice = calculateTotalPrice(product, subProduct);
    return { ...product, subProduct: subProduct.length ? subProduct : null, price: totalPrice.toFixed(2) };
  });
}

function findSubProducts(allProduct, estilo_dos_piezas, estilo) {
  if (!estilo_dos_piezas) return [];
  return allProduct.filter(prd => {
    const prdEstiloDos = prd.estilo_dos_piezas?.value?.trim().toLowerCase();
    const prdEstilo = prd.estilo?.value?.trim().toLowerCase();
    return estilo_dos_piezas === prdEstiloDos && estilo !== prdEstilo;
  });
}

function calculateTotalPrice(product, subProduct) {
  const productPrice = parseFloat(product.priceRange.minVariantPrice.amount || 0);
  const subProductPrice = subProduct.reduce((sum, sub) => sum + parseFloat(sub.priceRange.minVariantPrice.amount || 0), 0);
  return productPrice + subProductPrice;
}

function filterProductsByEstilo(products) {
  return products.filter(product => {
    const estilo_dos_piezas = product.estilo_dos_piezas?.value?.trim().toLowerCase();
    const estilo = product.estilo?.value?.trim().toLowerCase();
    if (!estilo_dos_piezas) return true;
    return estilo_dos_piezas && estilo.includes('t') && product.subProduct;
  });
}